export default __webpack_public_path__ + "static/terraform-dade68e666ac7b3afeb723ad1f2c77be.png";